import React, { useState } from 'react';
import axios from 'axios';
import NotesEditor from '../components/NotesEditor';
import '../styles/Notes.css';

function LoginPrompt({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('/api/auth/login', { password });
      localStorage.setItem('token', res.data.token);
      onLogin(res.data.token);
    } catch {
      setError('密码错误');
    }
  };

  return (
    <div className="notes-login">
      <form onSubmit={submit}>
        <h2>Notes</h2>
        <input type="password" placeholder="密码" value={password}
          onChange={e => setPassword(e.target.value)} autoFocus />
        {error && <p className="notes-login-error">{error}</p>}
        <button type="submit">进入</button>
      </form>
    </div>
  );
}

export default function Notes() {
  const [token, setToken] = useState(() => localStorage.getItem('token'));
  if (!token) return <LoginPrompt onLogin={setToken} />;
  return (
    <div className="notes-page">
      <NotesEditor token={token} />
    </div>
  );
}
